import AdminTopNav from "components/navigations/AdminNavs/AdminTopNav";
import AdminSideRecruiterNav from "components/navigations/AdminNavs/AdminSideRecruiterNav";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import RecruiterTopNav from "components/navigations/RecruiterTopNav";

export default function RecruiterLayerBlueprint(WrappedComponent) {
  return function RecruiterLayerComponent(props) {
    const appContext = useAppContext();
    const { account } = appContext;
    const { accountType } = account;

    if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <AdminTopNav />
          <AdminSideRecruiterNav />
          <section className="relative top-[60px] left-[250px]" style={{ width: "calc(100% - 250px)" }}>
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
      return (
        <div className="min-h-screen max-h-screen relative top-[60px]">
          <RecruiterTopNav />
          <WrappedComponent {...props} />
        </div>
      );
    } else return <ErrorPage />;
  };
}
